import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import type { NavigateParams } from '@/hooks/utils/useNavigate';
import type { ObjectivesLocationState } from '@/navigation/objectivesRoutes';

import { useGoBackOr } from '@/hooks/utils/useGoBackOr';

/**
 * Where the "Back" of an objectives screen leads: a step back when the navigation that opened the
 * screen says the one it left is there (`ObjectivesLocationState`), `fallback` otherwise.
 */
export const useObjectivesStepBack = () => {
    const { state } = useLocation<ObjectivesLocationState | undefined>();
    const goBackOr = useGoBackOr();
    const canStepBack = !!state?.canStepBack;

    const stepBackOr = useCallback(
        (fallback: NavigateParams) => goBackOr(canStepBack, fallback),
        [goBackOr, canStepBack],
    );

    return { canStepBack, stepBackOr };
};
